import PropTypes from "prop-types";

const CARD_WIDTH_CLASS_NAMES = {
  default: "auth-card-default",
  wide: "auth-card-wide",
};

const CardShell = ({ children, size = "default" }) => (
  <div className="auth-page">
    <div
      className={`card border shadow-sm mx-auto w-100 ${CARD_WIDTH_CLASS_NAMES[size]}`}
    >
      <div className="card-body p-4">{children}</div>
    </div>
  </div>
);

CardShell.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.keys(CARD_WIDTH_CLASS_NAMES)),
};

export default CardShell;
